import React, { Component } from 'react'
  import { init } from 'ityped'
  
  export default class Typewriting extends Component {
    componentDidMount(){
      const myElement = document.querySelector('#myElement')
      init(myElement, { showCursor: false, strings: ["A Programmer!", "A Developer!", " A quote writer!","A Tech Enthusiast!" ] })
    }
    render(){
      return <div id="myElement"></div>
    }
  }
